import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import coverImage from "../../../media/images/headCover.svg";
import AuthFooter from "../../layout/AuthLayout/Footer";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import { digitsEnToFa } from "@persian-tools/persian-tools";
export default function TermsPage() {
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader title="قوانین و مقررات" hasScroll={hasScroll} />

      <Box
        ref={divRef}
        sx={{
          // minWidth: "480px",
          maxWidth: "600px",
          // border: "1px solid gray",
          marginX: "auto",
          overflowX: "auto",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          paddingY: "20px",
          gap: "12px",
        }}
      >
        <Box
          sx={{
            backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            flexDirection: "column",
            borderRadius: "20px",
            justifyContent: "end",
            paddingX: "16px",
            boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              marginTop: "60px",
              color: "background.default",
            }}
          >
            قوانین و مقررات
          </Typography>
          <Typography
            variant="h6"
            sx={{
              marginBottom: "16px",
              color: "background.default",
            }}
          >
            آخرین بروزرسانی: دهم اسفند ۱۴۰۲ - ۱۴۰۲/۱۲/۱۰{" "}
          </Typography>
        </Box>
        <Typography
          variant="body9"
          sx={{
            padding: "4px 8px",
            textAlign: "center",
          }}
        >
          قوانین و مقرراتی که هر کاربر برای ثبت‌نام و استفاده از اپلیکشن
          می‌بایست آن را تایید کند.
        </Typography>

        <Box
          sx={{
            flex: 1,
            borderRadius: "20px",
            padding: "12px",
            backgroundColor: "info.light",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "primary.main",
              textAlign: "center",
            }}
          >
            قوانین عمومی :
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="body5">۱. استفاده از سرویس:</Typography>
              <Typography variant="body9">
                {" "}
                الزامی است که از این سرویس به نحوی استفاده کنید که با قوانین و
                مقررات مربوط به حقوق دیگران هماهنگ باشد. همچنین تضمین می‌شود که
                استفاده شما مسئولانه و مجاز باشد.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="body5">
                {digitsEnToFa(2)}. حقوق مالکیت و تکنولوژی:{" "}
              </Typography>
              <Typography variant="body9">
                {" "}
                تمامی حقوق مالکیت فکری و تکنولوژی مرتبط با این سرویس به مالک و
                توسعه‌دهنده تعلق دارد. هرگونه استفاده غیرمجاز از منابع و اطلاعات
                تکنولوژیکی ممکن است تحت پیگرد قانونی قرار گیرد.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="body5">۳. حریم خصوصی: </Typography>
              <Typography variant="body9">
                {" "}
                ما به حریم خصوصی شما ارزش می‌دهیم و از اطلاعات شخصی شما با
                احترام برخورد می‌کنیم. لطفاً سیاست حریم خصوصی ما را برای درک
                بهتر از چگونگی استفاده و حفاظت اطلاعات مطالعه کنید.
              </Typography>
            </Box>
          </Box>
        </Box>
        <AuthFooter />
      </Box>
    </>
  );
}
